import styled from '@emotion/styled'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const FooterContainer = styled(Container)`
  label: FooterContainer;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 16px;
  background-color:${(props) => props.theme.backgrounds.backGround1};
  strong {
    color: ${(props) => props.theme.colors.navColor};
  }
  .col-sm-8 h5 + p {
    max-width: 490px;
  }
`
export const FooterLogoContainer = styled('div')`
  label: FooterLogoContainer;
  margin-bottom: 2rem;
  padding-top: 3rem;
  max-height: 200px;
  justify-content: center;
  display: flex;
`

export const FooterLinks = styled('a')`
  label: FooterLinks;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 16px;
  margin-bottom: 0.6rem;
  cursor: pointer;
  font-weight: 900;
  text-decoration: none;
  display: block !important;
  :hover {
    text-decoration: none;
    color: ${(props) => props.theme.colors.navColor};
  }
`
export const FooterDomLinks = styled(Link)`
  label: FooterDomLinks;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 16px;
  margin-bottom: 0.6rem;
  font-weight: normal;
  font-weight: 900;
  text-decoration: none;
  display: block !important;
  :hover {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`

export const FooterHr = styled('hr')`
  label: FooterHr;
  border-color: rgba(0, 0, 0, 0.2);
  border-width: 1px;
  margin-top: 0;
  margin-bottom: 2rem;
`

export const QuickLinkBlock = styled('p')`
label: QuickLinkBlock;
margin-bottom: 0;
> a {
  &:hover {
    color: ${(props) => props.theme.colors.navColor};
  }
}
`

export const FooterBGDiv = styled.div`
  label:  FooterBGDiv;
  width: 100%;
  background-color: ${(props) => props.theme.backgrounds.backGround1};
`